module.exports = __webpack_public_path__ + "img/178.3db747b8.jpg";